import { ImageFormats } from '../types/image-validations';
export const MAX_IMAGE_DIMENSION_VALUE_IN_PIXELS = 4000;
export const MAX_SIZE_IN_MEGAPIXELS = 16;
export const VALID_URL_REGEX = new RegExp(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/);
export const DEFAULT_VALIDATION_RULES = {
    size: 10,
    dimensions: {
        minWidth: 300,
        maxWidth: MAX_IMAGE_DIMENSION_VALUE_IN_PIXELS,
        minHeight: 300,
        maxHeight: MAX_IMAGE_DIMENSION_VALUE_IN_PIXELS,
    },
    format: [
        ImageFormats.JPEG,
        ImageFormats.JPG,
        ImageFormats.PNG,
        ImageFormats.WEBP,
        ImageFormats.GIF,
        ImageFormats.SVG,
        ImageFormats.TIFF,
    ],
};
//# sourceMappingURL=constants.js.map